import React from "react";
import Label from "components/general/Label"
import { arraysEqual } from 'helpers/utils'
import Accordion from 'react-bootstrap/Accordion';
import SjpExpandedDefault from "components/sports/sjp/helper/SjpExpandedDefault";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


export const TableExpanded = React.memo((props) => {
    const { mirs_discipline,mirs_event_rsc } = useUrlFriendlyToParameters()
    const { row } = props;
    const { officials } = props;
    const { dataFirstRound } = props;

    let judges = []
    let f = 0
    officials.map((i) => {
        if(i?.function?.description === 'Judge')
        {
            judges[f++] = i
        }
    })

    let final = mirs_event_rsc.includes('FNL-0002')

    if(final)
    {
        return (
                <Accordion alwaysOpen>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header><Label data="HeaderRND_1" /></Accordion.Header>
                        <Accordion.Body>
                            <SjpExpandedDefault row={dataFirstRound} extendedResults={dataFirstRound?.extendedResults} judges={judges}/>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header><Label data="HeaderFinalRound" /></Accordion.Header>
                        <Accordion.Body>                            
                            <SjpExpandedDefault row={row} extendedResults={row?.extendedResults} judges={judges}/>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
        );
    }
    else
    {
        return (
            <SjpExpandedDefault row={row} extendedResults={row?.extendedResults} judges={judges}/>
        )
    }
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    console.log(arraysEqual(prevProps.row.extendedResults, nextProps.row.extendedResults))
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row.extendedResults, nextProps.row.extendedResults)
    )
});